<template>
  <MenuPopper
    :trigger-label="$t('userManual')"
    trigger-classes="hover:text-primary hover:underline"
  >
    <template #menu>
      <div class="flex flex-col gap-y-2">
        <button
          class="w-full flex gap-x-3 pe-12 items-center hover:text-primary px-3 py-1.5"
          @click="toggleUserManualAr()"
        >
          <faChevronRight :class="{ 'rotate-90': isUserManualAr }" class="w-2 fill-primary" />
          <span class="hover:text-primary"> العربية </span>
        </button>
        <div v-if="isUserManualAr" class="w-full flex flex-col gap-y-2">
          <button
            :key="key"
            v-for="(item, key) in items"
            class="w-full text-start px-8 py-1.5 text-primary hover:text-primary-700 hover:bg-gray-200"
            @click="downloadManual('ar', item)"
          >
            {{ $t(item) }}
          </button>
        </div>
        <button
          class="w-full flex gap-x-3 pe-12 items-center hover:text-primary px-3 py-1.5"
          @click="toggleUserManualEn()"
        >
          <faChevronRight :class="{ 'rotate-90': isUserManualEn }" class="w-2 fill-primary" />
          <span class="hover:text-primary"> English </span>
        </button>
        <div v-if="isUserManualEn" class="w-full flex flex-col gap-y-2">
          <button
            :key="key"
            v-for="(item, key) in items"
            class="w-full text-start px-8 py-1.5 text-primary hover:text-primary-700 hover:bg-gray-200"
            @click="downloadManual('en', item)"
          >
            {{ $t(item) }}
          </button>
        </div>
      </div>
    </template>
  </MenuPopper>
</template>

<script setup>
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'
import MenuPopper from '@/components/Buttons/MenuPopper.vue'
import { useToggle } from '@vueuse/core'
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()

const items = computed(() => {
  return ['typingCenter', 'individual', 'establishment']
})

const [isUserManualAr, toggleUserManualAr] = useToggle()
const [isUserManualEn, toggleUserManualEn] = useToggle()

const downloadManual = (locale, item) => {
  var links = [
    globalStore.clientConfig.host + '/manual/new/' + item + '/' + locale + '/echannels.pdf' /*,
            window.config.host + '/manual/' + "amwal" + '/' + language + '/Amwal.pdf'*/
  ]
  var link = document.createElement('a')
  link.setAttribute('download', 'manual_' + locale + '_' + item.label)
  link.style.display = 'none'
  document.body.appendChild(link)
  for (var i = 0; i < links.length; i++) {
    link.setAttribute('href', links[i])
    link.setAttribute('target', '_blank')
    link.click()
  }
  document.body.removeChild(link)
}
</script>

<style lang="scss" scoped></style>
